module.exports = __webpack_public_path__ + "static/media/uber.a05ffcd2.png";